import type { AnalyticsObject, AnalyticsProperties } from '../types'
export class HeaderLanguage implements AnalyticsObject {
  name: string
  properties: HeaderLanguageProperties
  constructor(properties: HeaderLanguageProperties) {
    this.name = `Header Language`
    this.properties = properties
  }
}
export interface HeaderLanguageProperties extends AnalyticsProperties {
  headerLanguageItemTargetLang?: string
}
